import React, { forwardRef, useImperativeHandle, useState } from 'react'

import { Botao, Carregando, ModalBase, PdfViewer } from 'src/componentes'
import { Api } from 'src/servicos'

import { AcoesModal, ContainerPDFViewer, CorpoModal, TituloModal } from './styles'

export interface ModalEnviarTermoRescisaoRef {
  abrir: (protocoloId: string) => void
  fechar: () => void
}

interface ModalEnviarTermoRescisaoProps {
  backdrop?: boolean
  aoEnviar: () => void
}

const ModalEnviarTermoRescisaoComponente: React.ForwardRefRenderFunction<
  ModalEnviarTermoRescisaoRef,
  ModalEnviarTermoRescisaoProps
> = ({ backdrop, aoEnviar }, ref) => {
  const [aberta, definirAberta] = useState(false)
  const [id, definirId] = useState<string>(null)
  const [url, definirUrl] = useState<string>(null)
  const [carregandoPrevia, definirCarregandoPrevia] = useState(false)
  const [enviando, definirEnviando] = useState(false)

  const fechar = () => {
    definirAberta(false)
    definirId(null)
    definirUrl(null)
    definirEnviando(false)
  }

  // Cada abertura gera uma prévia nova — o recálculo embutido na geração do PDF garante que os
  // valores exibidos estão sempre atuais, mesmo que o modal seja aberto e fechado várias vezes.
  // Se a prévia falhar (o interceptor global já exibe o toast de erro), fecha o modal em vez de
  // deixá-lo aberto sem PDF e sem nenhuma indicação do que houve.
  const abrir = async (protocoloId: string) => {
    definirId(protocoloId)
    definirAberta(true)
    definirCarregandoPrevia(true)
    try {
      const urlPdf = await Api.ObterTermoRescisaoPrevia(protocoloId)
      definirUrl(urlPdf)
    } catch {
      fechar()
    } finally {
      definirCarregandoPrevia(false)
    }
  }

  useImperativeHandle(ref, () => ({ abrir, fechar }))

  const enviar = async () => {
    try {
      definirEnviando(true)
      await Api.EnviarTermoRescisao(id)
      fechar()
      aoEnviar()
    } finally {
      definirEnviando(false)
    }
  }

  return (
    <ModalBase id="modal-enviar-termo-rescisao" aberta={aberta} backdrop={backdrop}>
      <CorpoModal>
        <TituloModal>Enviar termo de rescisão</TituloModal>
        {carregandoPrevia ? (
          <Carregando texto="Gerando prévia do termo..." />
        ) : (
          url && (
            <ContainerPDFViewer>
              <PdfViewer
                url={url}
                altura="600px"
                descricaoMobile="Clique no botão abaixo para baixar a prévia do termo"
                nomeArquivo="previa-termo-de-rescisao"
              />
            </ContainerPDFViewer>
          )
        )}
        <AcoesModal>
          <Botao
            texto="Cancelar"
            tema="Secundario"
            type="button"
            disabled={enviando}
            onClick={fechar}
          />
          <Botao
            texto="Enviar"
            type="button"
            disabled={carregandoPrevia}
            carregando={enviando}
            onClick={enviar}
          />
        </AcoesModal>
      </CorpoModal>
    </ModalBase>
  )
}

export const ModalEnviarTermoRescisao = forwardRef(
  ModalEnviarTermoRescisaoComponente
)
